import TableRow from './TableRow.vue'

export default {
    props: {
        retr: {
            type: Object,
            required: true
        }
    },

    components: {
        TableRow
    },

    data() {
        return {
            expandedIds: [],
            reclamations: null,
            reclamationsLoader: false
        }
    },

    provide() {
        return {
            retrType: this.retr.name
        }
    },

    methods: {
        toggleExpandable(idx) {
            if (!this.retr.list[idx]?.list?.length) {
                return
            }

            if (this.expandedIds.includes(idx)) {
                this.expandedIds = this.expandedIds.filter(id => id !== idx)
            } else {
                this.expandedIds.push(idx)
                this.fetchReclamations(this.retr.list[idx])
            }
        },

        async fetchReclamations({ contractor }) {
            if (!contractor) {
                return
            }
            const type = this.retr.name

            const reclamationExists = this.$store.getters['retr/reclamationExists']({
                contractor,
                type
            })

            if (reclamationExists) {
                // If reclamation is already fetched, do not fetch again
                return
            }

            this.reclamationsLoader = true

            const filters = this.$store.getters['retr/filters']
            const [quarter, year] = (filters.quarter.value || '').split('-')

            const payload = {
                contractor,
                locationId: filters.locationId.value,
                year: year || undefined,
                quarter: quarter || undefined,
                config: {
                    noCancel: true
                }
            }

            try {
                const { status, data } = await this.$store.dispatch('retrReclamations/fetchReclamations', payload)

                if (status !== 200 || !data?.data) {
                    throw new Error(data.message || 'Error fetchReclamations')
                }

                const reclamation = {
                    list: data.data.list,
                    year,
                    quarter,
                    type,
                    contractor
                }
                this.$store.commit('retr/ADD_RECLAMATION', reclamation)
            } catch (error) {
                this.reclamations = null
                console.error(error)
            } finally {
                this.reclamationsLoader = false
            }
        },

        async onReclamationClick(el, val) {
            const { default: ModalReclamation } = await import('./reclamations/ModalReclamation.vue')

            this.$store.dispatch('openModal', {
                component: ModalReclamation,
                args: {
                    type: this.retr.name,
                    contractor: el.contractor,
                    element: val.name || val
                }
            })
        }
    }
}